import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {UserModel} from '../../models/user/user.model';
import {Subject, takeUntil} from 'rxjs';
import { ReservedAppointmentsModel} from '../../models/appointment/appointment.model';
import {iResponse, iResponseList} from '../../models/response/response.model';
import {PatientService} from '../../services/patient/patient.service';
import {PatientModel} from '../../models/patient/patient.model';
import {MatDialog} from '@angular/material/dialog';
import {ApplicationCancelDialogComponent} from '../application-cancel-dialog/application-cancel-dialog.component';
import {AppointmentService} from '../../services/appointment/appointment.service';
import {InfoMessageService} from '../../services/infomessage/infomessage.service';
import {IconComponent} from '../shared/icon/icon.component';

@Component({
    selector: 'app-home',
    imports: [
        RouterLink,
        IconComponent
    ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.sass'
})
export class HomeComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>()
    user!: UserModel
    todayAppointments: ReservedAppointmentsModel[] = []

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private patientService: PatientService,
        private dialog: MatDialog,
        private appointmentService: AppointmentService,
        private infoMessageService: InfoMessageService
    ) {
    }

    ngOnInit() {
        if (this.authenticationService.isAuthenticated() && !this.authenticationService.hasRole(['admin'])) {
            const user = this.authenticationService.getUser();
            if(user.role === 'doctor') {
                this.router.navigate(['/doctor-dashboard'])
                return;
            } else if (user.role === 'patient') {
                this.router.navigate(['/profil-uebersicht'])
                return;
            } else if (user.role === 'admin') {
                this.router.navigate(['/app-administration'])
                return;
            }
        }

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    routeToLogin(): void {
        this.router.navigate(['/anmeldung'], {state: {booking: true}});
    }

    private getAppointments(): void {
        const now = new Date();
        const startOfDay = new Date(now.setHours(0, 0, 0, 0)).toISOString();
        const query = {
            from: startOfDay,
            isConfirmed: true,
        }

        // TODO set Query, when Backend is ready
        this.patientService.getPatientAppointments(this.user.id, query)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponseList<ReservedAppointmentsModel>) => {
                    this.todayAppointments = response.data
                },
                error: (error) => {
                }
            })
    }

    private getMe(): void {
        this.patientService.getMe()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<PatientModel>) => {
                    this.user = response.data;
                    this.getAppointments();
                },
                error: (error) => {
                    console.error(error)
                }
            })
    }

    private cancelAppointment(id: string, reason: string): void {
        this.appointmentService.patientCancelAppointment(id ,this.user.id, reason)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    this.getAppointments();
                },
                error: (error) => {
                    this.infoMessageService.createMessage('Der Termin kann nicht abgesagt werden, da schon ein Rezept ausgestellt wurde oder der Termin schon stattgefunden hat.', 'error')
                }
            })
    }
}
